import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Modal from "react-modal";
import { Bars } from "react-loader-spinner";


import DollarSign from '../../../assets/credit_card_icon.svg';
import CancelIcon from "../../../assets/cancel_icon.svg";
import { loadStripe } from "@stripe/stripe-js";


const HeaderSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 130.5%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
`


const InfoSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: rgba(255, 255, 255, 0.45);
`

const ActionButtonDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: static;
  width: 399px;
  height: 44px;
  background: #FFFFFF;
`

const ActionButtonTextSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
`


export default function AddCardInformationComponent(props){

    const [showLoader, setShowLoader] = useState(false);

    
    const handleModalCloseEvent = ()=>{
	props.setIsOpen(false);
    }

    let modalWidth = "446px";
    let modalHeight = "270px";
    
    return (
        <Modal
	    isOpen={props.isOpen}
	    style={{
		content: {
		    background: "#0F0F0F",
		    width: modalWidth,
		    height: modalHeight,
		    marginLeft: "auto",
		    marginRight: "auto",
		    marginTop: "auto",
		    marginBottom: "auto",
		    border:"none",
	    }}}
	>
            <div style={{
	        display: 'flex',
	        flexDirection: 'column',
	        position: 'relative',
	        alignItems: 'center'}}>
                <img onClick={()=>{props.handleModalCloseEvent()}}
		     src={CancelIcon}
		     style={{
			 position: "absolute", opacity: 0.4,
			 height: 14, width:14,
			 right:10, cursor:"pointer",
			 zIndex:10
		     }}
		/>
                <img src={DollarSign} style={{
                    width:42, height:42, marginTop:15}} />
                <HeaderSpan style={{marginTop:25}}>
	            Connect your card to bid
	        </HeaderSpan>
                <InfoSpan style={{marginTop:5}}>
                    Once you connect it, you'll be able<br/>
                    to buy
                </InfoSpan>
	        <ActionButtonDiv
	            style={{marginTop:24, cursor:"pointer"}}
	            onClick={()=>{
                        if(showLoader){
                            return;
                        }
                        setShowLoader(true);
                        props.moveToAddCard();
                        window.analytics.track('connect_card_button_pressed', {
                            from: window.location.href,
                            type: 'web'
                        }) 
                    }}>
                    {!showLoader && (
	                <ActionButtonTextSpan style={{
	                    userSelect: "none"
	                }}>
	                    CONNECT CARD
	                </ActionButtonTextSpan>
                    )}
                    {showLoader && (
                        <Bars
                            heigth="30" width="30"
                            color="grey"
                            ariaLabel="loading-indicator" />
                    )}
	        </ActionButtonDiv>

            </div>
        </Modal>
    );
}
